declare global {
  interface Window {
    zE?: (...args: unknown[]) => void;
  }
}

export const openZendeskWidget = () => {
  if (typeof window.zE !== "function") return;
  window.zE("webWidget", "show");
  window.zE("webWidget", "open");
};
